import type { UseFetchResourcesHookType } from '../../types';

/**
 * Check .native file for the implementation of this hook
 */
const useCachedInterfaceResources: UseFetchResourcesHookType = () => {
  return {
    isLoading: true,
    error: null,
    data: undefined,
    dataSources: undefined,
    interfacePage: undefined,
    interfacePageNamespace: undefined,
  };
};

export default useCachedInterfaceResources;
